import React, {createRef, useContext, useEffect, useState} from "react";
import $ from "jquery";
import StatisticContext from "../../../../context/StatisticContext";
import "../../../../css/form/SwitchItem.css";

const SwitchItem = props => {
    const { attribute, returnType, classname, list, value, change, loadingDependant } = props;
    const { loading } = useContext(StatisticContext);
    const [realValue, setRealValue] = useState(value);
    const idRandom = Math.floor(Math.random() * 999999);
    const itemRef = createRef();

    const valueChanged = type => {
        if (loadingDependant && loading.global)
            return;

        if (change === undefined)
            return;

        change(type);
    }
    const placeOverlay = () => {
        let selectedElmt = $("#item_" + idRandom + "_" + realValue);

        if (selectedElmt.length === 0)
            return;

        let overlayElmt = $("#overlay_" + idRandom);
        let position = getPosition();

        overlayElmt.css({ width: selectedElmt.width(), height: selectedElmt.height(), marginLeft: position.x });

        if (position.first) {
            overlayElmt.css({ borderRadius: "20px 0 0 20px" });
        }
        else if (position.last) {
            overlayElmt.css({ borderRadius: "0 20px 20px 0" });
        }
        else {
            overlayElmt.css({ borderRadius: "0" });
        }
    }
    const getPosition = () => {
        let first = false;
        let last = false;
        let x = 0;

        for (let i in list) {
            if (list[i].value === realValue) {
                if (parseInt(i) === 0)
                    first = true;
                else if (parseInt(i) === (list.length-1))
                    last = true;

                break;
            }

            x += $("#item_" + idRandom + "_" + list[i].value).width();
        }

        return {
            first,
            last,
            x
        };
    }

    useEffect(() => {
        setRealValue(value === "dual_day" ? "day" : value);
    }, [value]);
    useEffect(() => {
        placeOverlay();
    }, [realValue, itemRef]);

    return (
        <div className={"SwitchItem" + (classname !== undefined ? " " + classname : "") + (loadingDependant && loading.global ? " locked" : "")}>
            <div id={"overlay_" + idRandom} className={"overlay"} />
            {
                list.map((object, index) => (
                    <div key={index} id={"item_" + idRandom + "_" + object.value} ref={object.value === realValue ? itemRef : undefined} className={"item" + (realValue === object.value ? " selected" : "")} onClick={() => { valueChanged(object.value) }}>
                        <p className={"label"}>{ object.label }</p>
                    </div>
                ))
            }
        </div>
    )
}

export default SwitchItem;
